import { CategoryNode } from './types'

export const useFiltering = () => {
  // Функция для подсчета общего количества карточек в категории и всех её подкатегориях
  const getTotalCardCount = (category: CategoryNode): number => {
    let count = 0

    // Считаем карточки в самой категории
    if (category.card_ids && category.card_ids.length > 0) {
      count += category.card_ids.length
    }

    // Рекурсивно считаем карточки во всех подкатегориях
    if (category.subcategories && category.subcategories.length > 0) {
      category.subcategories.forEach(subcategory => {
        count += getTotalCardCount(subcategory)
      })
    }

    return count
  }

  // Функция для фильтрации категорий с карточками
  const filterCategoriesWithCards = (categoryList: CategoryNode[]): CategoryNode[] => {
    return categoryList.filter(category => getTotalCardCount(category) > 0)
  }

  const filterSubcategories = (subcategories: CategoryNode[], searchQuery?: string, parentName?: string, allCards?: any[]): CategoryNode[] => {
    // Сначала фильтруем категории с карточками
    const categoriesWithCards = filterCategoriesWithCards(subcategories)
    
    return categoriesWithCards.filter((subcat: CategoryNode) => {
      if (searchQuery) {
        // Проверяем название категории
        const categoryMatches = subcat.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          (parentName && parentName.toLowerCase().includes(searchQuery.toLowerCase()))
        
        // Если есть карточки, проверяем их названия
        let hasMatchingCards = false
        if (allCards && subcat.card_ids && subcat.card_ids.length > 0) {
          const categoryCards = allCards.filter(card => subcat.card_ids!.includes(card.card_id))
          hasMatchingCards = categoryCards.some(card => 
            card.title.toLowerCase().includes(searchQuery.toLowerCase())
          )
        }
        
        // Рекурсивно проверяем подкатегории
        let hasMatchingSubcategories = false
        if (subcat.subcategories && subcat.subcategories.length > 0) {
          const matchingSubcategories: CategoryNode[] = filterSubcategories(subcat.subcategories, searchQuery, subcat.name, allCards)
          hasMatchingSubcategories = matchingSubcategories.length > 0
        }
        
        return categoryMatches || hasMatchingCards || hasMatchingSubcategories
      }
      return true
    })
  }

  const filterCards = (cards: any[], cardIds: number[], searchQuery?: string, categoryName?: string) => {
    const categoryCards = cards.filter(card => cardIds.includes(card.card_id))
    
    return categoryCards.filter(card => {
      if (searchQuery) {
        return (
          card.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          (categoryName && categoryName.toLowerCase().includes(searchQuery.toLowerCase()))
        )
      }
      return true
    })
  }

  const filterAllCards = (cards: any[], searchQuery?: string) => {
    return cards.filter(card => {
      if (searchQuery) {
        return card.title.toLowerCase().includes(searchQuery.toLowerCase())
      }
      return true
    })
  }

  return {
    filterSubcategories,
    filterCards,
    filterAllCards,
    getTotalCardCount,
    filterCategoriesWithCards
  }
} 